import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../assets/css/theme.css';
import { colors } from '../assets/Colors';
import { fontText } from '../assets/fontConstant';
import logo from '../assets/img/logo.png';
import { IMG_URL } from '../utils/constant';

const PageNotFound = (props) =>{
	const { storeInfo } = props;
    let logo_img = logo;
    if (storeInfo && storeInfo.Logo && storeInfo.Logo.length) {
        logo_img = IMG_URL + storeInfo.Logo[0];
    }
    return (
        <div>
            <div  style={{display:"flex",
                        minHeight: "90vh",
                        justifyContent: "center",
                        alignItems: "center",
                        padding:"1rem"
                }}>
              
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-8 pull-xl-4 col-lg-7 pull-lg-5">
                                <div className="bg-white p-4 p-md-5 mb-4">
                                    <div className="row mb-2 thankyou-maindiv1">
                                        <div className="form-group thankyou-maindiv mb-2">
                                            <img
                                                className="storeclose33"
                                                alt="orderfail"
                                                src={logo_img}
                                            />
                                        </div>
                                        <div className="form-group thankyou-maindiv mt-3">
                                            <p
                                                className="mb-0 error404para"
                                                style={{
                                                    color: colors.primary,
                                                    fontFamily: fontText.NormalText,
                                                }}
                                            >
                                                Please scan the QR code to use "Food Ordering
                                                Application”
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
	return {
		storeInfo: state?.sessionReducer?.store_details || {},
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		//showCart: () => dispatch(showCart())
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(PageNotFound);
